import { cn, PaletteUtils } from '@shared/utils';
import { Icon, Text } from '@shared/widgets';
import ChevronIcon from '@assets/icons/chevron.svg';

interface UserItemProps {
  className?: string;
  letter: string;
  name: string;
}

export const UserItem = (props: UserItemProps) => {
  return (
    <div
      className={cn(
        'relative flex w-full items-center justify-between gap-3 rounded p-3 transition-colors duration-200',
        PaletteUtils.isInsigniaPalette && ['bg-white dark:bg-soft-black', 'hover:bg-gainsborough dark:hover:bg-transport-black'],
        PaletteUtils.isVcfcPalette && ['bg-ghost-white dark:bg-light/5', 'hover:bg-gainsborough dark:hover:bg-light/20'],
        props.className,
      )}
    >
      <div className='flex flex-shrink items-center gap-2'>
        <div className='flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-primary'>
          <Text weight='medium' size='2xl' color={PaletteUtils.isVcfcPalette ? 'white' : 'black'}>
            {props.letter}
          </Text>
        </div>
        <Text weight='medium' size='lg'>
          {props.name}
        </Text>
      </div>
      <Icon className='rotate-180' icon={<ChevronIcon />} />
    </div>
  );
};
